import { generatePath } from 'react-router-dom';
import { createApi } from '@reduxjs/toolkit/query/react';

import { URL } from 'api/constants';
import {
  providesList,
  cacheByIdArg,
  invalidatesList,
  cacheByIdArgProperty,
} from 'utils';

import { mockApiQuery } from '../../mockQuery';

import {
  MockItem,
  ListRequest,
  MockEditRequest,
  MockListResponse,
  MockCreateRequest,
  MockDetailsRequest,
} from './types';

const tagType = 'Mock';

export const mockApi = createApi({
  tagTypes: [tagType],
  reducerPath: 'mockApi',
  baseQuery: mockApiQuery,
  endpoints: (build) => ({
    create: build.mutation<void, MockCreateRequest>({
      invalidatesTags: invalidatesList(tagType),
      query: (data) => ({
        data,
        method: 'post',
        url: URL.MOCK_LIST,
      }),
    }),

    details: build.query<MockItem, MockDetailsRequest>({
      providesTags: cacheByIdArgProperty(tagType),
      query: ({ id }) => ({
        method: 'get',
        url: generatePath(URL.MOCK_DETAILS, { id }),
      }),
    }),

    edit: build.mutation<void, MockEditRequest>({
      invalidatesTags: (result, error, { id }) =>
        cacheByIdArg(tagType)(result, error, id),
      query: (data) => ({
        data,
        method: 'patch',
        url: URL.MOCK_DETAILS,
      }),
    }),

    list: build.query<MockItem[], ListRequest>({
      providesTags: (result) => providesList(tagType)(result),
      transformResponse: (response: MockListResponse) => response.data,
      query: (data) => ({
        data,
        method: 'get',
        url: URL.MOCK_LIST,
      }),
    }),
  }),
});

export const {
  useListQuery,
  useDetailsQuery,
  useEditMutation,
  useCreateMutation,
} = mockApi;
